import { endOfToday, startOfToday, subDays } from "date-fns";

import {
  FilterCondition,
  FilterFormData,
  Junction,
} from "src/base-components/FilterPopover/types";

export const DEFAULT_JUNCTION: Junction = "and";

export const MAX_FILTER_GROUPS = 3;
export const MAX_CONDITIONS_PER_GROUP = 5;

const DEFAULT_DATE_RANGE_DAYS = 7;

export const JUNCTION_OPTIONS: Array<{ key: string; value: string }> = [
  { key: "and", value: "and" },
  { key: "or", value: "or" },
];

export const buildFilterCondition = (
  junction: Junction = DEFAULT_JUNCTION,
): FilterCondition => ({
  junction,
  field: "",
  operator: "eq",
  value: "",
});

export const DEFAULT_FILTER_FORM_VALUES: FilterFormData = {
  filter_condition: {
    conditions: [
      {
        junction: DEFAULT_JUNCTION,
        conditions: [buildFilterCondition(DEFAULT_JUNCTION)],
      },
    ],
  },
};

export const getDefaultDateRange = (): { from: Date; to: Date } => ({
  from: subDays(startOfToday(), DEFAULT_DATE_RANGE_DAYS),
  to: endOfToday(),
});

export const getDefaultDateRangeJson = (): string => {
  const range = getDefaultDateRange();
  return JSON.stringify({
    from: range.from.toISOString(),
    to: range.to.toISOString(),
  });
};
